
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { RegionModel } from '../shared/models/region';
import { MenuSpocEmailModel, StateModel } from '../shared/models/state';
import { AdminDataProvider } from '../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../shared/providers/region.provider';
import { StateProvider } from '../shared/providers/state.provider';

@Component({
  selector: 'app-menu-spoc-email',
  templateUrl: './menu-spoc-email.component.html',
  styleUrls: ['./menu-spoc-email.component.scss']
})
export class MenuSpocEmailComponent implements OnInit {
  formGroup: FormGroup;
  modalRef: BsModalRef;
  filteredDetails: any = {
    search_string: "",
    module_id: [],
    states: [],
    city: [],
    regions: [],
    types: [],
    start_date: "",
    end_date: "",
  };
  filteredDetailsForApi: any = {
    search_string: "",
    module_id: "",
    states: "",
    city: "",
    regions: "",
    types: "",
    start_date: "",
    end_date: "",
  };
  resetFilteredDetailsForApi: any = {
    search_string: "",
    module_id: "",
    states: "",
    city: "",
    regions: "",
    types: "",
    start_date: "",
    end_date: "",
  };
  resetDropdown: boolean;
  regions: RegionModel[];
  states: StateModel[];
  page: number = 1;
  menuEmail: MenuSpocEmailModel[];
  getPaginationCount;
  resetData: any[];
  addOrEditState: string;
  submitted: boolean = false;
  @Input() model: MenuSpocEmailModel = new MenuSpocEmailModel;
  emailPattern = "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}";

  constructor(private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private formateDate: DateFormateService,
    public stateProvider: StateProvider,
    public regionProviders: RegionProvider,
    private router: Router,
    public adminDataProvider: AdminDataProvider,
    public alertService: AlertService) {

    this.formGroup = this.fb.group({
      spoc_email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      is_default: [0, Validators.required],
      region_id: ["", Validators.required],
      state_code: ["", Validators.required],
    });

  }

  /************************************/
  // convenience getter for easy access to form fields
  get f() {
    return this.formGroup.controls;
  }
  /*********************************** */

  ngOnInit() {
    this.getMenuSPOCEmail(this.filteredDetailsForApi);
  }

  getMenuSPOCEmail(data) {
    this.apiService
      .getHeaders(
        this.apiConfig.getMenuProgramEmail +
        "?page=" +
        this.page +
        "&search_string=" +
        data.search_string +
        "&region_id=" +
        data.regions +
        "&state_code=" +
        data.states
      )
      .subscribe(
        (res: any) => {
          this.menuEmail = res.body.data;
          console.log(res);
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");

          if (this.menuEmail.length > 0) {
            this.menuEmail.forEach((item) => {
              if (item.status == 1) {
                item.statusString = "Active";
              } else {
                item.statusString = "Inactive";
              }
              if (item.is_default == 1) {
                item.defalutString = "Yes";
              } else {
                item.defalutString = "No";
              }
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.states = this.stateProvider.state;
  }

  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.getMenuSPOCEmail(this.filteredDetailsForApi);
  }

  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 2: // State
        this.filteredDetails.states = await data;
        break;
      case 4: // resions
        this.filteredDetails.regions = await data;
        break;
      default:
        break;
    }
  }
  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.states = this.filteredDetails.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
    } catch (error) { }
    console.log(this.filteredDetailsForApi);
    this.getMenuSPOCEmail(this.filteredDetailsForApi);
  }

  filterResetListOfRecords() {
    this.resetDropdown = true;
    this.resetData = [];
    this.filteredDetails.search_string = "";
    this.filteredDetailsForApi = this.resetFilteredDetailsForApi;
    this.getMenuSPOCEmail(this.filteredDetailsForApi);
  }

  changeStatus(item: MenuSpocEmailModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateMenuProgramEmail + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
        this.getMenuSPOCEmail(this.filteredDetailsForApi);
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  addTemplate(template) {
    this.addOrEditState = "add";
    this.showStateModal(template);
    this.model = new MenuSpocEmailModel();
  }

  editState(template, item) {
    this.addOrEditState = "edit";
    this.model = item;
    this.stateFilteredByRegion = this.states.filter(
      (s) => s.region_id == item.region_id && s.state_year == 2021
    );
    this.model.state_code = item.state_code;
    this.showStateModal(template);
  }

  showStateModal(template) {
    this.modalService.open(template, {
      centered: true,
      backdrop: "static",
    });
  }

  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.submitted = false;
    this.modalService.dismissAll();
    this.formGroup.reset();
    this.model = new MenuSpocEmailModel();
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    let apiUrl;
    if (this.addOrEditState == "add") {
      apiUrl = this.apiConfig.createMenuProgramEmail;
      this.apiService.post(apiUrl, this.model).subscribe(
        (res: any) => {
          console.log("successfully Added", res);
          this.getMenuSPOCEmail(this.filteredDetailsForApi);
          this.alertService.success(res.body.data.message);
          this.clearSuccess();
          this.decline();
        },
        (err) => {
          console.log("err", err);
        }
      );
    } else if (this.addOrEditState == "edit") {
      apiUrl = this.apiConfig.updateMenuProgramEmail + "?id=" + this.model.id;
      this.apiService.put(apiUrl, this.model).subscribe(
        (res: any) => {
          console.log("successfully Updated", res);
          this.getMenuSPOCEmail(this.filteredDetailsForApi);
          this.alertService.success(res.data.message);
          this.clearSuccess();
          this.decline();
        },
        (err) => {
          console.log("err", err);
        }
      );
    }
  }

  stateFilteredByRegion: StateModel[];

  onChangeRegion(item) {
    this.stateFilteredByRegion = this.states.filter(
      (s) => s.region_id == item && s.state_year == 2021
    );
  }

}
